import {
  HOME_PATH,
  ERROR_PATH,
  ABOUT_PATH,
  INTERNAL_PROJECTS_PATH,
  HUMANITARIAN_CASES_PATH,
  ORPHAN_SPONSORSHIP_PATH,
  NEWS_PATH,
  LOGIN_PATH,
  REGISTER_PATH,
  NEWS_DETAILS_PATH,
  ORGANIZATIONAL_STRUCTURE_PATH,
  SEASONAL_PROJECTS_PATH,
  VIDEOS_PATH,
  BOARD_OF_DIRECTORS_PATH,
  DONATIONS_PATH,
  OUR_ACHIEVEMENTS_PATH,
  VISION_AND_MISSION_PATH,
  CONTACT_US_PATH,
  SPEACH_PAGE_PATH,
  PRIVACY_POLICY_PATH,
  HUMAN_PROJECT_DETAILS_PATH,
  RECENT_PROJECT_DETAILS_PATH,
  DONATIONS_WAYS_PATH,
  TERMS_PATH,
  TRANSACTION_PATH,
  EXTERNAL_PROJECTS_PATH,
  INTERNAL_SEASONAL_DETAILS,
  HELP_REQUEST_PATH,
  EXTERNAL_PROJECTS_DETAILS_PATH,
  DASHBOARD_PATH,
} from "Routes/paths";

import Home from "pages/Home/Home";
import About from "pages/About";
import OrganizationalStructure from "pages/OrganizationalStructure";
import Videos from "pages/Videos";
import BoardOfDirectors from "pages/BoardOfDirectors";
import Donations from "pages/Donations";
import OurAchievements from "pages/OurAchievements";
import VisionAndMission from "pages/VisionAndMission";
import ContactUs from "pages/ContactUs";
import SpeachPage from "pages/SpeachPage";
import PrivacyPolicy from "pages/PrivacyPolicy";
import RecentProjectsDetails from "pages/projectsDetails/RecentProjectsDetails";
import UserProtectedParent from "pages/UserProtectedRoutes/UserProtectedParent";
import DonationWays from "pages/DonationWays";
import TermsConditions from "pages/TermsConditions";
import Transaction from "pages/Transaction";
import News from "pages/News/News";
import NewsDetails from "pages/News/NewsDetails";
import OrphanSponsorship from "pages/Orphan/OrphanSponsorship";
import HumanitarianCases from "pages/HumanitarianCases/HumanitarianCases";
import HumanProjectDetails from "pages/HumanitarianCases/HumanProjectDetails";
import InternalProjects from "pages/CharityProjects/InternalProjects/InternalProjects";
import SeasonalProjects from "pages/CharityProjects/SeasonalProjects/SeasonalProjects";
import ExternalProjects from "pages/CharityProjects/ExternalProjects/ExternalProjects";
import InternalSeasonalDetails from "pages/CharityProjects/InternalSeasonalDetails";
import HelpRequest from "pages/HelpRequest";
import ErrorPathPage from "pages/ErrorPathPage";
import Login from "pages/auth/Login";
import Register from "pages/auth/Register";
import ExternalProjectDetails from "pages/CharityProjects/ExternalProjects/ExternalProjectDetails";
import Dashboard from "pages/UserProfile/Dashboard";

type RoutesType = {
  path: string;
  element: any;
  parent?: any;
};

export const routes: RoutesType[] = [
  {
    path: ERROR_PATH,
    element: <ErrorPathPage />,
  },
  {
    path: HOME_PATH,
    element: <Home />,
  },
  {
    path: ABOUT_PATH,
    element: <About />,
  },
  {
    path: INTERNAL_PROJECTS_PATH,
    element: <InternalProjects />,
  },
  {
    path: EXTERNAL_PROJECTS_PATH,
    element: <ExternalProjects />,
  },
  {
    path: `${EXTERNAL_PROJECTS_DETAILS_PATH}/:id`,
    element: <ExternalProjectDetails />,
  },
  {
    path: HUMANITARIAN_CASES_PATH,
    element: <HumanitarianCases />,
  },
  {
    path: ORPHAN_SPONSORSHIP_PATH,
    element: <OrphanSponsorship />,
  },
  {
    path: NEWS_PATH,
    element: <News />,
  },
  {
    path: `${NEWS_DETAILS_PATH}/:id`,
    element: <NewsDetails />,
  },
  {
    path: LOGIN_PATH,
    element: <Login />,
  },
  {
    path: REGISTER_PATH,
    element: <Register />,
  },

  {
    path: ORGANIZATIONAL_STRUCTURE_PATH,
    element: <OrganizationalStructure />,
  },
  {
    path: SEASONAL_PROJECTS_PATH,
    element: <SeasonalProjects />,
  },
  {
    path: VIDEOS_PATH,
    element: <Videos />,
  },
  {
    path: BOARD_OF_DIRECTORS_PATH,
    element: <BoardOfDirectors />,
  },
  {
    parent: <UserProtectedParent />,
    path: DONATIONS_PATH,
    element: <Donations />,
  },
  {
    parent: <UserProtectedParent />,
    path: DASHBOARD_PATH,
    element: <Dashboard />,
  },
  {
    path: DONATIONS_PATH,
    element: <Donations />,
  },
  {
    // parent: <UserProtectedParent />,
    path: TRANSACTION_PATH,
    element: <Transaction />,
  },
  {
    path: OUR_ACHIEVEMENTS_PATH,
    element: <OurAchievements />,
  },
  {
    path: VISION_AND_MISSION_PATH,
    element: <VisionAndMission />,
  },
  {
    path: CONTACT_US_PATH,
    element: <ContactUs />,
  },
  {
    path: DONATIONS_WAYS_PATH,
    element: <DonationWays />,
  },
  {
    path: SPEACH_PAGE_PATH,
    element: <SpeachPage />,
  },
  {
    path: TERMS_PATH,
    element: <TermsConditions />,
  },
  {
    path: HELP_REQUEST_PATH,
    element: <HelpRequest />,
  },
  {
    path: PRIVACY_POLICY_PATH,
    element: <PrivacyPolicy />,
  },
  {
    path: `${INTERNAL_SEASONAL_DETAILS}/:id`,
    element: <InternalSeasonalDetails />,
  },
  {
    path: `${HUMAN_PROJECT_DETAILS_PATH}/:id`,
    element: <HumanProjectDetails />,
  },
  {
    path: `${RECENT_PROJECT_DETAILS_PATH}/:id`,
    element: <RecentProjectsDetails />,
  },
];
